import { render } from "./PokemonPage.vue?vue&type=template&id=e431a272&scoped=true"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import "./PokemonPage.vue?vue&type=style&index=0&id=e431a272&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\cursos\\udemy\\curso-vue-cero-experto\\04-pokemon-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e431a272"]])

export default __exports__